import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function listSections(pageId) {
  const response = await axiosClient.get(
    `/api/admin/pages/${pageId}/sections`
  );
  return unwrapApiResponse(response);
}

export async function createSection(pageId, payload) {
  const response = await axiosClient.post(
    `/api/admin/pages/${pageId}/sections`,
    payload
  );
  return unwrapApiResponse(response);
}

export async function updateSection(sectionId, payload) {
  const response = await axiosClient.put(
    `/api/admin/sections/${sectionId}`,
    payload
  );
  return unwrapApiResponse(response);
}

export async function deleteSection(sectionId) {
  const response = await axiosClient.delete(
    `/api/admin/sections/${sectionId}`
  );
  return unwrapApiResponse(response);
}
